import {useReportsSpreadsheetContext} from 'modules/reports/components/Spreadsheet/ReportsSpreadsheet.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import useStyles from './ReportsSpreadsheetBody.styles'
import ReportsSpreadsheetRow from 'modules/reports/components/Spreadsheet/Row'

type Props = {}

function ReportsSpreadsheetBody(props: Props) {
  const classes = useStyles()
  const {prefix, data} = useReportsSpreadsheetContext()
  const p = usePrefix(prefix + '-body')

  return (
    <tbody className={classes.root} data-testid={p()}>
      {data.map((item, index) => (
        <ReportsSpreadsheetRow key={index} data={item} index={index} />
      ))}
    </tbody>
  )
}

export default ReportsSpreadsheetBody
